import {FormControl, InputLabel, MenuItem, Select, SelectChangeEvent} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {setFreeRoomSearchStateEndTimeFrame} from "../../../../data/room/freeRoomSearchStateSlice";
import {searchTimes} from "../../../../util/searchTimes";
import {useEffect, useState} from "react";

export const EndTimeSelection = () => {
    return (
        <>
            <EndTimeSelectionInner/>
        </>
    )
}

const EndTimeSelectionInner = () => {

    const mobileClient: boolean = useAppSelector(state => state.clientState.mobile);
    const selectedEndTime = useAppSelector(state => state.freeRoomSearchState.freeRoomSearch.endTimeframe);
    const selectedStartTime = useAppSelector(state => state.freeRoomSearchState.freeRoomSearch.startTimeframe);
    const dispatch = useAppDispatch();

    const [data, setData] = useState(searchTimes);

    useEffect(() => {
        if (selectedStartTime !== "") {
            setData(searchTimes.filter((time) => time.value > selectedStartTime))
        }
    }, [selectedStartTime]);

    const handleChange = (event: SelectChangeEvent<string>) => {
        dispatch(setFreeRoomSearchStateEndTimeFrame(event.target.value));
    }

    if (mobileClient) {
        return (
            <MobileView data={data} selectedClassId={selectedEndTime} handleChange={handleChange}/>
        )
    } else {
        return (
            <DesktopView data={data} selectedClassId={selectedEndTime} handleChange={handleChange}/>
        )
    }

}

const DesktopView = (props) => {
    const {t} = useTranslation();
    const state: boolean = (props.selectedClassId === "" || props.selectedClassId === undefined);
    return (
        <>
            <FormControl fullWidth size="small" error={state}>
                <InputLabel id="class-select-label">{t("selectionBoxes.endTimeSelection.title")}</InputLabel>
                <Select disabled={props.data.length === 0} labelId="class-select-label" id="class-select"
                        value={props.selectedClassId} label={t("selectionBoxes.endTimeSelection.title")}
                        onChange={props.handleChange}>
                    {
                        props.data.map((classes) =>
                            <MenuItem value={classes.value} key={classes.name}>
                                {classes.name}
                            </MenuItem>)
                    }
                </Select>
            </FormControl>
        </>
    );
}

const MobileView = (props) => {
    const {t} = useTranslation();
    const state: boolean = (props.selectedClassId === "" || props.selectedClassId === undefined);
    return (
        <>
            <FormControl fullWidth size="small" error={state}>
                <InputLabel id="class-select-label">{t("selectionBoxes.endTimeSelection.mobile.title")}</InputLabel>
                <Select disabled={props.data.length === 0} labelId="class-select-label" id="class-select"
                        value={props.selectedClassId} label={t("selectionBoxes.endTimeSelection.mobile.title")}
                        onChange={props.handleChange}>
                    {
                        props.data.map((classes) =>
                            <MenuItem value={classes.value} key={classes.name}>
                                {classes.name}
                            </MenuItem>)
                    }
                </Select>
            </FormControl>
        </>
    );
}